// 📊 Edusense Project 도메인 전용 클라이언트
// 완전 독립적인 Project API 클라이언트 (deprecated edusense-client 사용 안함)

// 생성된 Project API와 타입들을 export
// Orval이 생성한 Project 관련 React Query hooks와 API 함수들
export * from './client_gen_gen_generated';